function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react/no-danger */
import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withReactBootstrap } from '@demant/react-bootstrap';
import Card from './card';
var Cards = function Cards(_ref) {
  var results = _ref.results,
    isDesktop = _ref.isDesktop,
    dictionary = _ref.dictionary,
    selectedId = _ref.selectedId,
    isSelected = _ref.isSelected,
    areSelected = _ref.areSelected,
    type = _ref.type;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAll = _useState2[0],
    setShowAll = _useState2[1];
  var showItem = function showItem(index, selectedId, resultId) {
    if (selectedId === resultId) {
      return true;
    }
    if (showAll) {
      return true;
    }
    if (!isDesktop && index > 0) {
      return false;
    }
    if (isDesktop && index > 3) {
      return false;
    }
    return true;
  };
  var toggleShowAll = function toggleShowAll() {
    setShowAll(!showAll);
  };
  var renderShowAllButton = function renderShowAllButton() {
    return isDesktop && results.length > 4 && !selectedId || !isDesktop && results.length > 1 && !selectedId;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "cg__cards ".concat(results.length === 0 ? 'cg__cards--empty' : '', " ").concat(showAll ? ' show-all ' : '')
  }, results.map(function (result, index) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: index
    }, (selectedId === 0 || selectedId === '' || selectedId === result.id) && /*#__PURE__*/React.createElement(Card, {
      type: type,
      key: index,
      areSelected: areSelected,
      selectedId: selectedId,
      isSelected: isSelected,
      dictionary: dictionary,
      data: result,
      className: showItem(index, selectedId, result.id) ? '' : 'hidden'
    }), isDesktop && index === 3 && !showAll ? renderShowAllButton() && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "cg__cards__button",
      onClick: toggleShowAll
    }, showAll ? "".concat(dictionary ? dictionary.hide : '') : "".concat(dictionary ? dictionary.showAll : '')) : '', !isDesktop && index === 1 && !showAll ? renderShowAllButton() && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "cg__cards__button",
      onClick: toggleShowAll
    }, showAll ? "".concat(dictionary ? dictionary.hide : '') : "".concat(dictionary ? dictionary.showAll : '')) : '');
  }), results.length === 0 && /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: dictionary ? dictionary.noResult : ''
    }
  })), renderShowAllButton() && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "".concat(!showAll ? 'show-all' : '', " cg__cards__button"),
    onClick: toggleShowAll
  }, showAll ? "".concat(dictionary ? dictionary.hide : '') : "".concat(dictionary ? dictionary.showAll : '')));
};
Cards.propTypes = {
  results: PropTypes.arrayOf(PropTypes.object).isRequired,
  isDesktop: PropTypes.bool.isRequired,
  dictionary: PropTypes.object.isRequired,
  selectedId: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]),
  isSelected: PropTypes.bool,
  areSelected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  type: PropTypes.string
};
export default withReactBootstrap(Cards);